<template>
    <div>
        <v-btn v-if="!hideActivator" @click="show" text class="normal-btn">
            {{ $t('common.without_team') }}
            <v-icon>mdi-chevron-down</v-icon>
        </v-btn>

        <base-dialog :loading="loading" :value="dialog" :width="440" :title="$t('common.add_to_group')" @input="onInput" @close="hide">
            <div class="dialog-field">
                <span class="dialog-field-label">{{ $t('common.team') }}</span>
                <kimsa-combobox :placeholder="$t('common.select_team')" dense :items="teams" @change="team = $event"
                    :value="team" />
            </div>
            <div class="dialog-field">
                <span class="dialog-field-label">{{ $t('common.subgroup') }}</span>
                <kimsa-combobox :placeholder="$t('common.select_subgroup')" dense :items="subgroups"
                    @change="subgroup = $event" :value="subgroup" :readonly="!team" />
            </div>

            <template #footer>
                <dialog-actions :confirm-label="$t('common.add')" :disabled="isDisabled" :loading="loading"
                    @cancel="hide" @confirm="save" />
            </template>
        </base-dialog>
    </div>
</template>

<script>
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import { db } from "@/utils/Firebase";
import BaseDialog from '@/components/common/BaseDialog';
import DialogActions from '@/components/common/DialogActions';

export default {
    name: "SelectEvaluationGroupStudentDialog",
    components: { KimsaCombobox, BaseDialog, DialogActions },
    props: {
        teams: {
            type: Array,
            default: () => [],
        },
        studentId: {
            type: String,
            default: null
        },
        hideActivator: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            team: null,
            subgroup: null,
        }
    },
    computed: {
        isDisabled(vm = this) {
            if (vm.team === undefined) {
                return false
            } else if (vm.currentTeam) {
                return !vm.subgroup
            } else {
                return !!(!vm.team || !vm.subgroup)
            }
        },
        findTeam(vm = this) {
            return vm.teams.find(team => team.id === vm.currentTeam?.id || null) || null
        },
        findGroup(vm = this) {
            return vm.findTeam?.evaluationGroups?.find(group => group.id === vm.currentTeam?.subgroupId || null) || null
        },
        subgroups(vm = this) {
            return vm.team?.evaluationGroups || []
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.team = null
            vm.subgroup = null
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                let students = [...vm.subgroup.students, vm.studentId]

                let groups = [...vm.team?.evaluationGroups || []]
                let findGroupIndex = vm.team?.evaluationGroups?.findIndex(group => group.id === vm.subgroup?.id || null)
                groups[findGroupIndex].students = students
                let evaluationTeam = { id: vm.team.id, subgroupId: vm.subgroup.id }
                await db.collection('users').doc(vm.studentId).update({ evaluationTeam })
                await db.collection('teams').doc(vm.team.id).update({ evaluationGroups: groups })

                vm.$emit('save', { studentId: vm.studentId, evaluationTeam })
                vm.hide()
            })
        },
    },
    watch: {
        team(val) {
            if (this.currentTeam?.id !== val?.id) this.subgroup = null
        }
    }
}
</script>

<style scoped>
.dialog-field {
    margin-bottom: 14px;
}

.dialog-field:last-child {
    margin-bottom: 0;
}

.dialog-field-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
    margin-bottom: 6px;
}
</style>
